import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { Typography, Button, Container } from "@hegias/ui-components";
import { useHistory, useLocation, useParams } from "react-router-dom";
import useAuth from "../../contexts/Auth/useAuth";
import * as ROUTES from "../../common/routes.constants";

interface ErrorContent {
	title: string;
	description: string;
	imagePath: string;
}

export type ErrorCode = "404" | "500";

const errorsMap = new Map<string, ErrorContent>([
	[
		"404",
		{
			title: "app.ErrorPage.title.404",
			description: "app.ErrorPage.description.404",
			imagePath: "/images/HegiasIllu404.png",
		},
	],
	[
		"500",
		{
			title: "app.ErrorPage.title.500",
			description: "app.ErrorPage.description.500",
			imagePath: "/images/HegiasIllu500.png",
		},
	],
]);

const ErrorPage = () => {
	const history = useHistory();
	const { search } = useLocation();
	const { t } = useTranslation();
	const { authenticated } = useAuth();
	const { errorCode } = useParams<{ errorCode: string }>();
	const [state, setState] = useState<ErrorContent>({
		title: "",
		description: "",
		imagePath: "",
	});

	const ERRORS = ["404", "500"];

	const handleBack = () => {
		history.goBack();
	};

	const handleToProjects = () => {
		history.push({
			pathname: `/${ROUTES.PROJECTS}`,
			search,
		});
	};

	useEffect(() => {
		if (!ERRORS.includes(errorCode)) {
			history.push({
				pathname: `/${ROUTES.ERROR}/404`,
				search,
			});
		} else {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			setState(errorsMap.get(errorCode as ErrorCode)!);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [errorCode]);

	return (
		<StyledContainer>
			<Typography variant="h1" color="primary">
				{t(state.title)}
			</Typography>
			<Typography variant="p">{t(state.description)}</Typography>
			<StyledButtons>
				{history?.length > 1 && (
					<Button onClick={handleBack}>{t("app.global.btn.back")}</Button>
				)}
				{authenticated && (
					<Button onClick={handleToProjects}>
						{t("app.global.btn.backToProjects")}
					</Button>
				)}
			</StyledButtons>
			<img alt="hegias-error" src={state.imagePath} />
		</StyledContainer>
	);
};

const StyledContainer = styled(Container)`
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;

	> img {
		height: auto;
		width: 80%;
		max-width: 600px;
	}
`;

const StyledButtons = styled.div`
	margin-top: 1%;
	margin-bottom: 1%;
	width: 20%;
	display: flex;
	flex-direction: row;
	justify-items: center;
	justify-content: space-evenly;
	align-items: center;
`;

export default ErrorPage;
